import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import Loader from "../../commonComponent/Loader";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import ApiConfig from "../../config/ApiConfig";
import { getMyGroupList } from "../../services/GroupService";
import { addCareTeam } from "../../services/CareTeam";
import { useCareTeamContext } from "../../Context/CareTeamContext";

const AssignGrouptoCareTeam = ({
  selectedTeam,
  members,
  getAllProviders,
  modalOpen,
  setModalOpen,
}) => {
  const [teamId, setTeamId] = useState(members);
  const [team, setTeam] = useState([]);
  const [removeGroupsModal, setRemoveGroupsModal] = useState([]);
  const [groupIdList, setGroupIdList] = useState([]);
  const [groupLists, setGroupLists] = useState([]);
  const [filterdata, setFilterData] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const { setGroupSignal } =
  useCareTeamContext();
  // const [modalOpen, setModalOpen] = useState(false); // Track modal open state

  const getGroupLists = async () => {
    try {
      const response = await getMyGroupList();

      if (response.status === 200) {
        setLoader(false);
        setGroupLists(response?.data?.data);
        setFilterData(response?.data?.data);
        setTimeout(() => {}, 1000);
      } else {
        showToastError(response?.data || response.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const UpdateGroup = (checked, id) => {
    if (checked) {
      // Checkbox is checked, add the patient to the selectedPatientList
      setGroupIdList((prevList) => [...prevList, id]);
    } else {
      // Checkbox is unchecked, filter out the patient with the specified id
      setGroupIdList((prevList) =>
        prevList.filter((patientId) => patientId !== id)
      );
    }
  };

  const handleUpdateGroup = async () => {
    try {
      let payload = {
        ...team,
        teamMeambers: team.teamMeambers?.map((member) => member._id),
        programs: team.programs.map((item) => item._id),
        groups: [...groupIdList],
      };
      if (!payload) return;
      const response = await addCareTeam(payload, teamId);
      if (response.status !== 200) {
        showToastError("Error while updating");
        return;
      }
      showToastSuccess("Group Assigned Successfully");
      setGroupSignal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (e) => {
    let searchWord = e.target.value;
    const result = groupLists.filter((value) => {
      if (value) {
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });

    if (searchWord === "") {
      setFilterData(groupLists);
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
    }
  };

  //   useEffect(() => {
  //     if (group.length > 0) {
  //       const careMember = group[0]?.careTeamMembers;
  //       setCareTeamMemberList([...careMember, providerId]);
  //     }
  //   }, [group.length]);

  useEffect(() => {
    if (modalOpen) {
      getGroupLists();
      setTeamId(members);
      setTeam(selectedTeam);
      setGroupSignal(false);
      let group = selectedTeam.groups.map((group) => group._id);
      setRemoveGroupsModal(group);
      setGroupIdList(group);
    }
  }, [modalOpen]);

  //   useEffect(() => {
  //     if(members){
  //         console.log("selected Team ====>", selectedTeam, members);
  //         setTeamId(members);
  //         setTeam(selectedTeam);
  //         setRemoveGroupsModal(selectedTeam.groups)
  //     }
  //   }, [members]);

  return (
    <div
      className="modal fade"
      id="assigngroupproviders"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content px-4">
          <div className="modal-header px-4 border-0">
            <h5 className="modal-title">Assign to Care team</h5>
            <button
              type="button"
              id="btn-close"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setModalOpen(false);
                setTeam([]);
                setGroupSignal(true);
              }}
            ></button>
          </div>
          <div className="modal-body pt-4 pb-2 px-4 ">
            <div
              style={{
                marginTop: "-10px",
                display: "flex",
                justifyContent: "end",
                marginBottom: "10px",
                marginLeft: "-5px",
              }}
            >
              <div className="actsearch_box1">
                <FiSearch className="boxicon" />
                <input
                  placeholder="Search Here..."
                  className="ms-2"
                  onChange={(e) => onSearch(e)}
                />
              </div>
            </div>

            <div className="col-md-12 p-1">
              <div
                className="memlist_scroll mt-1 justify-content-center spacing_scroll"
                style={{ height: 300 }}
              >
                {isLoading ? (
                  <center>
                    <Loader
                      visible={isLoading}
                      style={{ top: "48px", position: "relative" }}
                    />
                  </center>
                ) : filterdata?.length ? (
                  filterdata
                    .filter((dt) => !removeGroupsModal.includes(dt._id))
                    .map((dt, index) => {
                      let image = dt?.groupImage;
                      if (dt?.groupImage.includes("https")) {
                        let htImage = dt?.groupImage?.split("/");
                        image = htImage[htImage?.length - 1];
                      }
                      return (
                        <div
                          key={index}
                          // className={`card mb-2 p-1 ${index == 0 ? "active" : ""}`}
                          className={`card mb-2 py-2 px-3`}
                          style={{ background: "#F2F4F6" }}
                          onClick={() => {}}
                          id={dt._id}
                        >
                          <div className="btn-group  align-items-center gap-2">
                            <p className="affir_checkbox mb-0">
                              <input
                                type="checkbox"
                                name="members"
                                value={dt._id}
                                id="flexCheckDefault"
                                checked={groupIdList?.includes(dt._id)}
                                onChange={(e) =>
                                  UpdateGroup(e.target.checked, e.target.value)
                                }
                              />
                            </p>

                            <div
                              className="p-0 actlist_wid1 d-flex mb-0 justify-content-center align-items-center affir_checkbox"
                              htmlFor="flexCheckDefault"
                            >
                              <img
                                src={
                                  ApiConfig.ImageUrl +
                                  "groups/" +
                                  dt.createdBy +
                                  "/" +
                                  image
                                }
                                onError={(e) => {
                                  e.target.src = "/images/avatar.png"; //replacement image imported above
                                }}
                                alt=""
                                className="member_listimage"
                              />
                            </div>
                            <div className=" actlist_wid2 ms-2">
                              <p className="py-0 mb-0">{`${dt.groupName}`}</p>
                            </div>
                          </div>
                          {/* <div className="table_resouter card bg-light p-2 my-2">
                                                        <table className="table mb-0 table-borderless table_resinner4">
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={2}><span className="fw-bold">Qualifications: </span> 
                                                                    {Array.isArray(dt.qualifications)
                                                                    ? dt?.qualifications.length > 0
                                                                        ? dt.qualifications.map((item, idx, arr) => {
                                                                        return (
                                                                            <Fragment key={idx}>
                                                                            {item.name}
                                                                            {arr.length - 1 == idx ? "" : ", "}
                                                                            </Fragment>
                                                                        );
                                                                        })
                                                                        : "N/A"
                                                                    : dt.qualifications}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='text-capitalize'><span className="fw-bold">Category:</span> {dt.docCategory}</td>
                                                                    <td><span className="fw-bold">Year of experience:</span>  {dt.yearsOfExperience}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div> */}
                        </div>
                      );
                    })
                ) : (
                  <p className="p-2">No data found!</p>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer px-3 border-0 mb-3">
            <button
              type="button"
              onClick={() => {
                handleUpdateGroup();
                getAllProviders();
                setModalOpen(false);
                setTeam([]);
              }}
              data-bs-dismiss="modal"
              // disabled={check===0}
              className="description_btnsave w-100"
              style={{
                backgroundColor: "#1f7e78",
                borderColor: "#1f7e78",
              }}
            >
              {"Assign"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignGrouptoCareTeam;
